import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { TinymceComponent } from '../editors/tinymce/tinymce.component';
// import { TinyMceModule } from 'angular-tinymce';
// import { tinymceDefaultSettings } from 'angular-tinymce';
import { NgxMaskModule } from 'ngx-mask';
import { NgChatModule } from 'ng-chat';

import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireModule } from 'angularfire2';

import { DataTableModule } from 'angular-4-data-table-bootstrap-4';

// import the ChartModule for the Chart component
import { ChartModule } from '@syncfusion/ej2-angular-charts';
import { CategoryService, LegendService, TooltipService } from '@syncfusion/ej2-angular-charts';
import { DataLabelService, LineSeriesService } from '@syncfusion/ej2-angular-charts';

import { SharedModule } from '../../shared.module';
import { UscStoreService } from '../../services/usc-store/usc-store.service';

//import { HomeAuthResolver } from './home-auth-resolver.service';
import { UscNavComponent } from './usc-nav/usc-nav.component';
import { UscStoreComponent } from './usc-store.component';
// import { UscHomeModule } from './usc-home/usc-home.module';
import { UscNavModule } from './usc-nav/usc-nav.module';
import { UscHomeComponent } from './usc-home/usc-home.component';
import { UscHeaderComponent } from './usc-header/usc-header.component';
import { UscFooterComponent } from './usc-footer/usc-footer.component';
import { UscImpressionComponent } from './usc-impression/usc-impression.component';
import { UscFirstComponent } from './usc-first/usc-first.component';
import { UscMiddleComponent } from './usc-middle/usc-middle.component';
import { UscLastingComponent } from './usc-lasting/usc-lasting.component';
import { UscSearchComponent } from './usc-search/usc-search.component';

import { UscModalComponent } from './usc-modal/usc-modal.component';
import { UscDialogComponent } from './usc-dialog/usc-dialog.component';
import { UscChatTemplateDlgComponent } from './usc-chat-template-dlg/usc-chat-template-dlg.component';
import { UscUserLookupComponent } from './usc-user-lookup/usc-user-lookup.component';
import { UserListComponent } from '../list/user-list/user-list.component';
import { UscEmailComposerComponent } from './usc-email-composer/usc-email-composer.component';
import { UscReportsComponent } from './usc-reports/usc-reports.component';
// import { AttachmentListComponent } from '../list/attachment-list/attachment-list.component';
import { UscAttachmentLookupComponent } from './usc-attachment-lookup/usc-attachment-lookup.component';
import { UserLookupComponent } from '../lookup/user-lookup/user-lookup.component';
// import { AttachmentLookupComponent } from '../lookup/attachment-lookup/attachment-lookup.component';
import { UscUserProfileComponent } from './usc-user-profile/usc-user-profile.component';
import { UscCampaignImportComponent } from './usc-campaign-import/usc-campaign-import.component';
import { UscManageCampaignComponent } from './usc-manage-campaign/usc-manage-campaign.component';
import { UscPasswordComponent } from './usc-password/usc-password.component';
import { UscChatDetailsComponent } from './usc-chat-details/usc-chat-details.component';
import { UscCalendarViewComponent } from './usc-calendar-view/usc-calendar-view.component';
import { CalendarModule } from 'angular-calendar';
import { UscSmsHostingComponent } from './usc-sms-hosting/usc-sms-hosting.component';
import { UscTimeslotPickerComponent } from './usc-timeslot-picker/usc-timeslot-picker.component';
import { UscBookOfBusinessComponent } from './usc-book-of-business/usc-book-of-business.component';
import { UscNotificationComponent } from './usc-notification/usc-notification.component';
import { UscNextActionPlanComponent } from './usc-next-action-plan/usc-next-action-plan.component';
import { UscThisActionPlanComponent } from './usc-this-action-plan/usc-this-action-plan.component';
import { UscP2wNavComponent } from './usc-p2w-nav/usc-p2w-nav.component';
import { UscActionPlanComponent } from './usc-action-plan/usc-action-plan.component';
import { UscTodaysGoalComponent } from './usc-todays-goal/usc-todays-goal.component';
import { UscPayoutEstimatorComponent } from './usc-payout-estimator/usc-payout-estimator.component';
import { UscSalesTrackerComponent } from './usc-sales-tracker/usc-sales-tracker.component';
import { UscMonthlySalesPanelComponent } from './usc-monthly-sales-panel/usc-monthly-sales-panel.component';
import { UscSalesBarComponent } from './usc-sales-bar/usc-sales-bar.component';
import { UscDailySalesPanelComponent } from './usc-daily-sales-panel/usc-daily-sales-panel.component';
import { UscTop10ResultPanelComponent } from './usc-top10-result-panel/usc-top10-result-panel.component';
import { UscYourAchievementsPanelComponent } from './usc-your-achievements-panel/usc-your-achievements-panel.component';
import { UscTeamSalesTrackerComponent } from './usc-team-sales-tracker/usc-team-sales-tracker.component';
import { UscP2wSalesDetailsComponent } from './usc-p2w-sales-details/usc-p2w-sales-details.component';
import { UscTeamActionPlansComponent } from './usc-team-action-plans/usc-team-action-plans.component';
import { UscP2wCompetitionsComponent } from './usc-p2w-competitions/usc-p2w-competitions.component';
import { UscP2wCompetitionStatusComponent } from './usc-p2w-competition-status/usc-p2w-competition-status.component';
import { UscP2wAssociateDetailResultsComponent } from './usc-p2w-associate-detail-results/usc-p2w-associate-detail-results.component';
import { UscPreviousActionPlansComponent } from './usc-previous-action-plans/usc-previous-action-plans.component';
import { UscPrevActionPlanComponent } from './usc-prev-action-plan/usc-prev-action-plan.component';
import { UscRetailFoundationsComponent } from './usc-retail-foundations/usc-retail-foundations.component';
import { UscSalesScorecardComponent } from './usc-sales-scorecard/usc-sales-scorecard.component';
import { UscSalesDetailComponent } from './usc-sales-detail/usc-sales-detail.component';
import { UscTodaysGoalTableComponent } from './usc-todays-goal-table/usc-todays-goal-table.component';
import { UscActionPlanTableComponent } from './usc-action-plan-table/usc-action-plan-table.component';
import { UscP2wWaitingComponent } from './usc-p2w-waiting/usc-p2w-waiting.component';
import { UscP2wTeamActionPlansComponent } from './usc-p2w-team-action-plans/usc-p2w-team-action-plans.component';
import { UscSvtCheckinComponent } from '../usc-store-scheduling/usc-svt-checkin/usc-svt-checkin.component';
import { UscSvtWaitingComponent } from '../usc-store-scheduling/usc-svt-waiting/usc-svt-waiting.component';
import { UscSvtAppointmentsComponent } from '../usc-store-scheduling/usc-svt-appointments/usc-svt-appointments.component';
import { UscSvtServiceCompletedComponent } from '../usc-store-scheduling/usc-svt-service-completed/usc-svt-service-completed.component';
import { UscSvtServingNowComponent } from '../usc-store-scheduling/usc-svt-serving-now/usc-svt-serving-now.component';
import { UscSvtNavComponent } from '../usc-store-scheduling/usc-svt-nav/usc-svt-nav.component';
import { UscMetricsBarComponent } from './usc-metrics-bar/usc-metrics-bar.component';
import { UscMonthlySalesPanelAdvancedComponent } from './usc-monthly-sales-panel-advanced/usc-monthly-sales-panel-advanced.component';
import { UscDailySalesPanelAdvancedComponent } from './usc-daily-sales-panel-advanced/usc-daily-sales-panel-advanced.component';
import { UscStoreSchedulingSetupComponent } from '../usc-store-scheduling/usc-store-scheduling-setup/usc-store-scheduling-setup.component';
import { UscUploadedDocumentsComponent } from './usc-uploaded-documents/usc-uploaded-documents.component';
import { UscDocNavComponent } from './usc-doc-nav/usc-doc-nav.component';
import { UscLeadsContactedWidgetsComponent } from './usc-leads-contacted-widgets/usc-leads-contacted-widgets.component';
import { UscDashboardNavComponent } from './usc-dashboard-nav/usc-dashboard-nav.component';
import { UscLeadsContactedLeaderboardComponent } from './usc-leads-contacted-leaderboard/usc-leads-contacted-leaderboard.component';
import { UscDashboardWidgetsComponent } from './usc-dashboard-widgets/usc-dashboard-widgets.component';
import { UscDashboardLeaderboardComponent } from './usc-dashboard-leaderboard/usc-dashboard-leaderboard.component';
import { UscViewDescBubbleComponent } from './usc-view-desc-bubble/usc-view-desc-bubble.component';

const uscStoreRouting: ModuleWithProviders = RouterModule.forChild([{
    path: 'usc-store',
    component: UscStoreComponent,
    // resolve: {
    //   isAuthenticated: HomeAuthResolver
    // }
}]);

export const firebaseConfig = {
    apiKey: "AIzaSyBnPrWO-n7d7ZPhxrU96kvB2otxHHCsHgg",
    authDomain: "sn-rn-a874c.firebaseapp.com",
    databaseURL: "https://sn-rn-a874c.firebaseio.com",
    projectId: "sn-rn-a874c",
    storageBucket: "sn-rn-a874c.appspot.com",
    messagingSenderId: "987512148290",
    appId: "1:987512148290:web:e8290ac3959ac1c181b8db"
};


@NgModule({
    exports: [
    ],
    imports: [
        uscStoreRouting,
        SharedModule,
        // UscHomeModule,
        UscNavModule,
        DataTableModule,
        NgxMaskModule.forRoot(),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFireModule.initializeApp(firebaseConfig),
        CalendarModule.forRoot(),

        // Ng4FilesModule
        // syncfusion
        ChartModule,
        NgChatModule,
    ],
    declarations: [
        UscHomeComponent,
        UscStoreComponent,
        UscNavComponent,
        UscHeaderComponent,
        UscFooterComponent,
        UscDialogComponent,
        UscModalComponent,
        UscImpressionComponent,
        UscFirstComponent,
        UscMiddleComponent,
        UscLastingComponent,
        UscSearchComponent,
        UserLookupComponent,
        UscUserLookupComponent,
        UserListComponent,
        UscEmailComposerComponent,
        UscReportsComponent,
        UscBookOfBusinessComponent,
        UscAttachmentLookupComponent,
        UscUserProfileComponent,
        UscCampaignImportComponent,
        UscManageCampaignComponent,
        UscPasswordComponent,
        UscChatTemplateDlgComponent,
        UscChatDetailsComponent,
        UscCalendarViewComponent,
        UscSmsHostingComponent,
        UscTimeslotPickerComponent,
        UscNotificationComponent,
        UscActionPlanComponent,
        UscActionPlanTableComponent,
        UscNextActionPlanComponent,
        UscThisActionPlanComponent,
        UscPrevActionPlanComponent,
        UscP2wNavComponent,
        UscTodaysGoalComponent,
        UscTodaysGoalTableComponent,
        UscPayoutEstimatorComponent,
        UscSalesTrackerComponent,
        UscTeamSalesTrackerComponent,
        UscMonthlySalesPanelComponent,
        UscDailySalesPanelComponent,
        UscSalesBarComponent,
        UscTop10ResultPanelComponent,
        UscYourAchievementsPanelComponent,
        UscSalesDetailComponent,
        UscP2wSalesDetailsComponent,
        UscTeamActionPlansComponent,
        UscP2wTeamActionPlansComponent,
        UscP2wSalesDetailsComponent,
        UscP2wCompetitionsComponent,
        UscP2wCompetitionStatusComponent,
        UscP2wAssociateDetailResultsComponent,
        UscPreviousActionPlansComponent,
        UscRetailFoundationsComponent,
        UscSalesScorecardComponent,
        UscSvtNavComponent,
        UscP2wWaitingComponent,
        UscSvtCheckinComponent,
        UscSvtWaitingComponent,
        UscSvtAppointmentsComponent,
        UscSvtServingNowComponent,
        UscSvtServiceCompletedComponent,
        UscMetricsBarComponent,
        UscMonthlySalesPanelAdvancedComponent,
        UscDailySalesPanelAdvancedComponent,
        UscStoreSchedulingSetupComponent,
        UscUploadedDocumentsComponent,
        UscDocNavComponent,
        UscLeadsContactedWidgetsComponent,
        UscDashboardNavComponent,
        UscLeadsContactedLeaderboardComponent,
        UscDashboardWidgetsComponent,
        UscDashboardLeaderboardComponent,
        UscViewDescBubbleComponent
    ],
    providers: [
        UscStoreService,
        NgbModal,
        NgbActiveModal,
        // syncfusion
        CategoryService, LegendService, TooltipService, DataLabelService, LineSeriesService
    ],
    // add components here for dynamic loading
    entryComponents: [
        UscHomeComponent,
        UscModalComponent,
        UscDialogComponent,
        UscFirstComponent,
        UscMiddleComponent,
        UscLastingComponent,
        UscSearchComponent,
        UserLookupComponent,
        UscUserLookupComponent,
        UscEmailComposerComponent,
        UscReportsComponent,
        UscBookOfBusinessComponent,
        UscAttachmentLookupComponent,
        UscUserProfileComponent,
        UscCampaignImportComponent,
        UscManageCampaignComponent,
        UscPasswordComponent,
        UscChatTemplateDlgComponent,
        UscChatDetailsComponent,
        UscCalendarViewComponent,
        UscTimeslotPickerComponent,
        UscSmsHostingComponent,
        UscNextActionPlanComponent,
        UscThisActionPlanComponent,
        UscPrevActionPlanComponent,
        UscActionPlanTableComponent,
        UscTodaysGoalComponent,
        UscTodaysGoalTableComponent,
        UscPayoutEstimatorComponent,
        UscSalesTrackerComponent,
        UscTeamSalesTrackerComponent,
        UscP2wSalesDetailsComponent,
        UscTeamActionPlansComponent,
        UscP2wTeamActionPlansComponent,
        UscP2wSalesDetailsComponent,
        UscP2wCompetitionsComponent,
        UscP2wCompetitionStatusComponent,
        UscP2wAssociateDetailResultsComponent,
        UscPreviousActionPlansComponent,
        UscRetailFoundationsComponent,
        UscSalesScorecardComponent,
        UscP2wWaitingComponent,
        UscSvtCheckinComponent,
        UscSvtWaitingComponent,
        UscSvtAppointmentsComponent,
        UscSvtServingNowComponent,
        UscSvtServiceCompletedComponent,
        UscStoreSchedulingSetupComponent,
        UscUploadedDocumentsComponent,
        UscLeadsContactedWidgetsComponent,
        UscLeadsContactedLeaderboardComponent,
        UscDashboardWidgetsComponent,
        UscDashboardLeaderboardComponent
    ]
})

export class UscStoreModule { }



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-store.module.ts